export const NARROW_REM = 40;

export const MOTION_PRESS_MS = 60;
export const MOTION_FAST_MS = 100;
export const MOTION_PROGRESS_MS = 140;
export const MOTION_TOAST_MS = 500;

export const Z_STICKY = 20;
export const Z_DIFF_FULLSCREEN = 80;
export const Z_OVERLAY = 2_147_483_000;
export const Z_DIALOG = 2_147_483_100;
